import $ from 'jquery';
import simpleParallax from 'simple-parallax-js';
import {
  gsap,
  Power1,
  Power2,
  Power4,
  Linear,
  TweenMax,
  TimelineMax
} from "gsap";
import {
  ScrollTrigger
} from "gsap/ScrollTrigger";

import {
  ScrollMagicPluginGsap
} from "scrollmagic-plugin-gsap";





//gsap.registerPlugin(ScrollTrigger, EaselPlugin, PixiPlugin, TextPlugin,CSSRulePlugin);



$(document).ready(function() {

  const boxes = gsap.utils.toArray('.section-ox');

  boxes.forEach((box, i) => {
    const anim = gsap.fromTo(box, {
      autoAlpha: 0,
      y: 50
    }, {
      duration: 1,
      autoAlpha: 1,
      y: 0
    });
    ScrollTrigger.create({
      trigger: box,
      animation: anim,
      toggleActions: 'play none none none',
      once: true,
    });
  });


});
gsap.set(".txt-studio h1", {
  opacity: 0,
  y: '150px'
});
gsap.to(".txt-studio h1", {
  y: 0,
  opacity: 1,
  ease: "expo",
  scrollTrigger: {
    trigger: ".txt-studio",
    start: "top center",
    end: "top 100px",
  }
});
gsap.set(".txt-studio span", {
  opacity: 0,
  x: 400
});
gsap.to(".txt-studio span", {
  x: 0,
  opacity: 1,
  rotation: 360,
  scrollTrigger: {
    trigger: ".txt-studio",
    start: "top center",
    end: "top 100px",
  }
});


var image = document.getElementsByClassName('img-parallax');
new simpleParallax(image);


var parallax_catch = document.getElementsByClassName('icon-catch');
new simpleParallax(parallax_catch, {
	orientation: 'right',
});
var parallax_cloud = document.getElementsByClassName('icon-cloud');
new simpleParallax(parallax_cloud, {
	orientation: 'right',
});
 var parallax_services = document.getElementsByClassName('img-bg-services');
 new simpleParallax(parallax_services, {
  scale: 1.1,
  orientation:'right'
 });
 var thunder = document.getElementsByClassName('img-thunder');
new simpleParallax(thunder, {
  scale: 1.2
});
var hand = document.getElementsByClassName('team-hand');
new simpleParallax(hand, {
 scale: 1.1,
 orientation:'left'
});


function animateFrom(elem, direction) {
  direction = direction || 1;
  var x = 0,
      delayV = 0,
      y = direction * 100;
  if(elem.classList.contains("gs_reveal_fromLeft")) {
    x = -100;
    y = 0;
  } else if (elem.classList.contains("gs_reveal_fromRight")) {
    x = 100;
    y = 0;
  } else if (elem.classList.contains("gs_reveal_fromTop")) {
    x = 0;
    y = 100;
  } else if (elem.classList.contains("gs_reveal_fromMiniLeft")) {
    x = 20;
    y = 0;
  } else if (elem.classList.contains("gs_reveal_fromTopMini")) {
    x = 0;
    y = 20;
  }
  if (elem.classList.contains("delay_01")) {
    delayV = 0;
  }else if (elem.classList.contains("delay_02")) {
  delayV = 0.2;

  }
  if (elem.classList.contains("delay_03")) {
  delayV = 0.4;
 }

 if (elem.classList.contains("delay_04")) {
   delayV = 0.6;

}
if (elem.classList.contains("delay_05")) {
  delayV = 0.8;
}
  elem.style.transform = "translate(" + x + "px, " + y + "px)";
  elem.style.opacity = "0";
  gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
    duration: 1.75,
    x: 0,
    y: 0,
    scale:1,
    autoAlpha: 1,
    delay:delayV,
    ease: "expo",
    stagger: {
    	 each: 0.2,
    	 ease: "Sine.easeOut",
    },
    overwrite: "auto"
  });
}

function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}

document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".gs_reveal").forEach(function(elem) {
    hide(elem); // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      once: true,
      onEnter: function() { animateFrom(elem) },
      // onEnterBack: function() { animateFrom(elem, -1) },
      // onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
    });
  });
  //


  let canvas  = document.getElementById("green-buddy");
  let context = canvas.getContext("2d");
  canvas.width = 1158;
  canvas.height = 770;
  let frameCount = 26;
  const currentFrame = index => (
    `http://localhost:8000/assets/images/content/green-buddy_${(index + 1).toString().padStart(2, '0')}.png`
  );

  let images = []
  let greenbuddy = {
    frame: 0
  };

  for (let i = 0; i < frameCount; i++) {
    let img = new Image();
    img.src = currentFrame(i);
    images.push(img);
  }
  gsap.timeline({
    onUpdate: render,
    scrollTrigger: {
      trigger: "#mission",
      scrub: 0.2,
      markers: false
    }
  })
  .to(greenbuddy, {
    frame: frameCount - 1,
    snap: "frame",
    ease: "none",
    duration: 1
  }, 0);

  images[0].onload = render;

  function render() {
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(images[greenbuddy.frame], 0, 0);
  }
// blue buddy
let canvasBlue  = document.getElementById("blue-buddy");
let contextBlue = canvasBlue.getContext("2d");
canvasBlue.width = 1158;
canvasBlue.height = 770;
let frameCountBlue = 18;
const currentFrameBlue = index => (
  `http://localhost:8000/assets/images/content/blue-buddy_${(index + 1).toString().padStart(2, '0')}.png`
);

let imagesBlue = []
let bluebuddy = {
  frame: 0
};

for (let i = 0; i < frameCountBlue; i++) {
  let imgbuddy = new Image();
  imgbuddy.src = currentFrameBlue(i);
  imagesBlue.push(imgbuddy);
}
gsap.timeline({
  onUpdate: renderBlue,
  scrollTrigger: {
    trigger: "#mission",
    scrub: 0.2,
    markers: false
  }
})
.to(bluebuddy, {
  frame: frameCountBlue - 1,
  snap: "frame",
  ease: "none",
  duration: 1
}, 0);

imagesBlue[0].onload = renderBlue;

function renderBlue() {
  contextBlue.clearRect(0, 0, canvasBlue.width, canvasBlue.height);
  contextBlue.drawImage(imagesBlue[bluebuddy.frame], 0, 0);
}

// Plante Plante
let canvasplante  = document.getElementById("icon-a-kwk");
let contextplante = canvasplante.getContext("2d");
canvasplante.width = 1158;
canvasplante.height = 770;
let frameCountplante = 6;
const currentFrameplante = index => (
  `http://localhost:8000/assets/images/content/planet-buddy_${(index + 1).toString().padStart(2, '0')}.png`
);

let imagesplante = []
let plantebuddy = {
  frame: 0
};

for (let i = 0; i < frameCountplante; i++) {
  let imgplante = new Image();
  imgplante.src = currentFrameplante(i);
  imagesplante.push(imgplante);
}
gsap.timeline({
  onUpdate: renderplante,
  scrollTrigger: {
    trigger: ".icon-a-kwk",
    scrub: 0.2,
    markers: false
  }
})
.to(plantebuddy, {
  frame: frameCountplante - 1,
  snap: "frame",
  ease: "none",
  duration: 1
}, 0);

imagesplante[0].onload = renderplante;

function renderplante() {
  contextplante.clearRect(0, 0, canvasplante.width, canvasplante.height);
  contextplante.drawImage(imagesplante[plantebuddy.frame], 0, 0);
}
const headings = gsap.utils.toArray(".has-line");

headings.forEach((has_line) => {
    gsap.to(has_line, {
      scrollTrigger: {
        trigger: has_line,
        start: "top center",
        toggleClass:  "active-line",
        once: true
      }
    })
});
});
